import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetFirstDeliveryDayForPostcode {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService;

    /**
     * GetFirstDeliveryDayForPostcode constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Get the first delivery day via API for requested postcode.
     *
     * @param {String} postcode
     *
     * @returns {String}
     */
    async handle(postcode) {
        let apiUrl = url(ApiEndpoints['postcodes.first-delivery-day'], [postcode]);

        return this.apiService.get(apiUrl);
    }
}
